export default function AccessDeniedModal({
  open,
  action = 'view',
  routeLabel = '',
  onClose,
}) {
  if (!open) return null

  const normalized = String(action || 'view').toLowerCase()
  const title = normalized === 'view' ? 'Access Restricted' : 'Action Not Allowed'
  const message = normalized === 'view'
    ? 'You do not have permission to view this page.'
    : `You do not have permission to ${normalized} on this page.`

  return (
    <div className="fixed inset-0 z-[120] flex items-center justify-center bg-black/40 p-4 backdrop-blur-[2px]">
      <div className="w-full max-w-md rounded-2xl border border-white/35 bg-white/85 p-6 shadow-2xl backdrop-blur-xl">
        <div className="mb-4 flex items-center gap-3">
          <span className="material-symbols-outlined text-amber-600">lock</span>
          <h3 className="text-lg font-black text-on-surface">{title}</h3>
        </div>
        <p className="text-sm font-medium text-on-surface-variant">{message}</p>
        {routeLabel ? <p className="mt-2 text-xs font-bold uppercase tracking-wide text-on-surface-variant">{routeLabel}</p> : null}
        <div className="mt-6 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl bg-primary px-4 py-2 text-sm font-bold text-on-primary shadow-md"
          >
            Okay
          </button>
        </div>
      </div>
    </div>
  )
}
